import { forwardRef, type AnchorHTMLAttributes, type ReactNode } from "react";
import {
  IUBENDA_COOKIE_POLICY_URL,
  IUBENDA_EMBED_CLASS,
  IUBENDA_PRIVACY_POLICY_URL,
} from "@/constants/iubenda";

type IubendaPolicy = "privacy" | "cookie";

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  policy: IubendaPolicy;
  children: ReactNode;
};

const POLICY_URL: Record<IubendaPolicy, string> = {
  privacy: IUBENDA_PRIVACY_POLICY_URL,
  cookie: IUBENDA_COOKIE_POLICY_URL,
};

export const IubendaLink = forwardRef<HTMLAnchorElement, Props>(
  function IubendaLink({ policy, children, className, title, ...rest }, ref) {
    const label = typeof children === "string" ? children : "Policy";

    return (
      <a
        ref={ref}
        href={POLICY_URL[policy]}
        className={[IUBENDA_EMBED_CLASS, className].filter(Boolean).join(" ")}
        title={title ?? `${label} `}
        {...rest}
      >
        {children}
      </a>
    );
  },
);
